module.exports = __webpack_public_path__ + "static/media/20151231455.33caf18d.jpg";